<template>
    <app-layout :title="trans('bookings.page_title.index')">
        <template #header> {{ trans("bookings.page_title.index") }} </template>

        <Section>
            <Container>
                <div class="mb-8 flex justify-end space-x-2">
                    <!-- <Link :href="route('bookings.create')">
                        <StyledButton background-primary>
                            {{ trans("bookings.page_title.create") }}
                        </StyledButton>
                    </Link> -->
                    <div>
                        <input
                            @input="filter"
                            v-model="query"
                            type="search"
                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full border-gray-300 rounded-md"
                            placeholder="Suchen..."
                        />
                    </div>
                </div>

                <div>
                    <v-server-table
                        :options="options"
                        :url="route('api.bookings.index')"
                        :columns="columns"
                        ref="table"
                    >
                        <template v-slot:payment_status="props">
                            <div
                                v-if="props.row.total_paid_at"
                                class="flex items-center"
                            >
                                <CheckCircleIcon
                                    class="h-5 w-5 mr-1 text-green-500"
                                />
                                {{
                                    trans("bookings.payment_status.total_paid")
                                }}
                            </div>
                            <div
                                v-else-if="
                                    !props.row.total_paid_at &&
                                    props.row.deposit_paid_at
                                "
                                class="flex items-center"
                            >
                                <CheckCircleIcon
                                    class="h-5 w-5 mr-1 text-yellow-500"
                                />
                                {{
                                    trans(
                                        "bookings.payment_status.deposit_paid"
                                    )
                                }}
                            </div>
                            <div v-else class="flex items-center">
                                <CheckCircleIcon
                                    class="h-5 w-5 mr-1 text-orange-600"
                                />
                                {{ trans("bookings.payment_status.not_paid") }}
                            </div>
                        </template>

                        <template v-slot:actions="props">
                            <booking-actions
                                :data="props.row"
                                :index="props.index"
                                @refresh="$refs.table.getData()"
                            ></booking-actions>
                        </template>
                    </v-server-table>
                </div>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BookingActions from "@/Pages/Bookings/BookingActions.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { LockClosedIcon } from "@heroicons/vue/outline";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import StyledButton from "@/Components/StyledButton.vue";
import { CheckCircleIcon } from "@heroicons/vue/outline";

export default {
    components: {
        AppLayout,
        BookingActions,
        Link,
        LockClosedIcon,
        Container,
        Section,
        StyledButton,
        CheckCircleIcon,
    },

    data() {
        return {
            query: null,
            debouncedFilter: null,
            columns: [
                "client",
                "start_date",
                "end_date",
                "vehicle",
                "total_price",
                "payment_status",
                "actions",
            ],
            options: {
                headings: {
                    start_date: this.trans("bookings.table.start_date"),
                    end_date: this.trans("bookings.table.end_date"),
                    client: this.trans("bookings.table.client"),
                    vehicle: this.trans("bookings.table.vehicle"),
                    total_price: this.trans("bookings.table.total_price"),
                    payment_status: this.trans("bookings.table.payment_status"),
                    actions: this.trans("vuetables.label.actions"),
                },

                texts: {
                    count: this.trans("vuetables.label.countText"),
                    filter: this.trans("vuetables.label.filter"),
                    noResults: this.trans("vuetables.label.noResults"),
                    loading: this.trans("vuetables.label.loading"),
                    filterPlaceholder: this.trans("vuetables.label.search"),
                },

                sortable: [],

                columnsDisplay: {
                    email: "min_tabletP",
                },

                rowClassCallback: (row) => {
                    if (row.is_done) {
                        return "bg-green-100";
                    }
                },
            },
        };
    },

    methods: {
        filter() {
            this.debouncedFilter();
        },
    },

    mounted() {
        this.debouncedFilter = _.debounce(() => {
            this.$refs.table.setFilter(this.query);
        }, 300);
    },
};
</script>
